"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classNames = _interopRequireDefault(require("../../utilities/classNames"));

var _checkCircle = _interopRequireDefault(require("@dcl/icons/lib/nucleo/small/user-interface/check-circle-08"));

var _alertCircleExc = _interopRequireDefault(require("@dcl/icons/lib/nucleo/small/user-interface/alert-circle-exc"));

var _AlertTypes = require("./AlertTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var renderAlertStateIcon = function renderAlertStateIcon(alertState) {
  switch (alertState) {
    case _AlertTypes.AlertState.SUCCESS:
      return /*#__PURE__*/_react["default"].createElement(_checkCircle["default"], {
        label: alertState,
        width: 24
      });

    case _AlertTypes.AlertState.FAILURE:
      return /*#__PURE__*/_react["default"].createElement(_alertCircleExc["default"], {
        label: alertState,
        width: 24
      });
  }
};

var Alert = function Alert(_ref) {
  var alertState = _ref.alertState,
      state = _ref.state,
      children = _ref.children,
      id = _ref.id;
  // eslint-disable-next-line
  alertState = alertState || state;
  var getClassName = (0, _classNames["default"])(Alert.displayName);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: getClassName({
      states: alertState
    }),
    role: "alert"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: getClassName({
      descendantName: "icon"
    })
  }, renderAlertStateIcon(alertState)), /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    className: getClassName({
      descendantName: "content"
    })
  }, children));
};

Alert.displayName = "Alert";
var _default = Alert;
exports["default"] = _default;